import React, {Component} from 'react'
import {Card, Container,Row,Col,Button} from 'react-bootstrap'
import "./Modal.css";
import {connect} from 'react-redux';
import * as actionTypes from '../../../../Action/Index';
import {Spinner} from 'react-bootstrap';

class First extends Component{
    
    clearTextHandler =()=>{
      this.email.value = "";
      this.props.onResetLinkChangeState();
     
    }
    forgotPasswordHandler = (e) => {
      e.preventDefault();
      console.log(this.props.type)
      if(this.props.type===false){
        this.props.onReceivingResetPasswordLink(e.target.email.value)
      }
      else{
        console.log('calling')
        this.props.interviewerSendEmail(e.target.email.value)
      }
    }
 
    render(){
      const cssClasses = [
        "Modal",
        this.props.show ? "ModalOpen" : "ModalClosed"
      ]
    return ( 
      <Container>
       {  this.props.passwordResetLinkSent ? this.props.modalHandler():null} 
      <Card className={cssClasses.join(' ')}>
      <Card.Body>
        <form onSubmit = {(e) => {this.forgotPasswordHandler(e)}}>
      <Row>
      <Col><h3 className='heading'>Forgot Password</h3></Col>
     </Row>
     <Row>
      <Col className='paragraph'>
         <p>Please enter your registered Email ID<br/>
         We will send you a link to reset your password.</p>
      </Col>
     </Row>
     
  
     <Row>
     <Col md={2}>
        <label className='emailid'>Email ID:</label>
     </Col>
     <Col md={10}>
     <input type='text' ref={element=>this.email = element} tabIndex="1" className='inputdivmodal' required maxLength="52"
     pattern = "\S+@\S+\.\S+" title = "Please Enter the Format in user@mail.com" name = "email"/>
     <span className="forgotSpinner">{this.props.loader?  <Spinner animation="border" variant="warning" />:null}</span>
     </Col>
     <Col md={12}>
     <span style={{color:"red",float:"left"}}>{this.props.passwordResetLinkSent? null : this.props.errorMsg }&nbsp;</span>
     </Col>
    </Row>

    <Row style={{marginTop:13}}>
      <Col md={6}>
      {/* <span style={{color:"red",marginLeft:-20}}>{this.props.passwordResetLinkSent? null : this.props.errorMsg }</span> */}
      </Col>
     <Col md={3}>
      <Button variant="outline-warning" className="sendCancel" tabIndex="3" onClick={(e)=>{this.props.closed();this.clearTextHandler()}} disabled={this.props.loader}>
      Cancel</Button>
    </Col>
    <Col md={3}>
      <Button type = "submit" variant="warning" tabIndex="2" className="sendLink" disabled={this.props.loader}>
      Send Link
     </Button>
     </Col>
    </Row>
    </form>
      </Card.Body>
      </Card>
       </Container>
     
    );
  };
}

const mapStateToProps = state => {
  return{
    passwordResetLinkSent: state.employeeReducer.emailLinkSentSuccess,
    errorMsg: state.employeeReducer.resetLinkErrorMsg,
    loader: state.employeeReducer.emailLinkSentLoader,
  }
}

const mapDispatchToProps = dispatch => {
  return{
    onReceivingResetPasswordLink: (email) => dispatch(actionTypes.getForgotPasswordLink(email,1)),
    onResetLinkChangeState:()=>dispatch(actionTypes.changeResetLinkState()),
    interviewerSendEmail:(email)=>dispatch(actionTypes.interviewerForgotPassword(email))
  }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(First);
  